'use client';

/**
 * The currency a person enters money in on the global desk.
 *
 * The India desk records money in rupees only (`DESK_CURRENCY = 'INR'` in its
 * `lib/format`). The global desk has no such constant: the org's own currency
 * (`local_billing_currency` — `organizations.billing_currency`, where the
 * customer *is*) wins, else the currency it is charged in (`billing_currency`,
 * always USD for a global org). Same rule as `lib/clm/helpers.ts::orgCurrencyOf`.
 *
 * Null while `/users/me` is loading — a CurrencyInput then shows a bare
 * number rather than a guessed symbol. A figure already recorded on a row in
 * another currency is displayed as recorded (`formatMoney(v, row.currency)`),
 * never relabelled with this one.
 */
import { useUsersMe } from './useUsersMe';

export function orgCurrency(
  org:
    | { local_billing_currency?: string | null; billing_currency?: string | null }
    | null
    | undefined,
): string | null {
  const c = (org?.local_billing_currency || org?.billing_currency || '').trim().toUpperCase();
  return /^[A-Z]{3}$/.test(c) ? c : null;
}

export function useOrgCurrency(): string | null {
  const me = useUsersMe();
  return orgCurrency(me.data?.org);
}
